
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import Vue from "vue";
import AIBotLoading from "./AIBotLoading.vue";
import FeatureBox from "./FeatureBox.vue";
import { mapGetters, mapActions } from "vuex";
import { AI_ASSESSMENT_QUESTION_TYPE_CONFIG } from "@/utils/assessment_sort_config";

interface Applicant {
  label: string;
  value: string;
  email: string;
}

export default Vue.extend({
  name: "LeftPanel",
  components: {
    AIBotLoading,
    FeatureBox
  },
  data() {
    return {
      editingQuestion: {
        question: "",
        options: [] as string[]
      },
      selectedApplicants: [] as Applicant[],
      loadingApplicants: false,
      ai_assessment_question_type_config: AI_ASSESSMENT_QUESTION_TYPE_CONFIG,
      searchInput: ""
    };
  },
  computed: {
    ...mapGetters("ai_assessment", [
      "aiIsLoading",
      "aiLoadingContext",
      "aiAssessmentData",
      "aiIsEditMode",
      "aiEditingQuestionIndex"
    ]),
    ...mapGetters("recruiter", [
      "SELECTED_APPLICANT",
      "FETCH_AVAILABLE_APPLICANTS"
    ]),
    applicantOptions() {
      return this.FETCH_AVAILABLE_APPLICANTS.map((applicant) => ({
        ...applicant,
        displayText: applicant.label
      }));
    }
  },
  async created() {
    await this.loadAvailableApplicants();
  },
  methods: {
    ...mapActions("ai_assessment", ["startEditingQuestion", "saveQuestion"]),
    ...mapActions("recruiter", ["ASSIGN_ASSESSMENT_TO_APPLICANTS"]),
    startEditingQuestion(index: number) {
      if (this.aiAssessmentData && this.aiAssessmentData.questions[index]) {
        const question = this.aiAssessmentData.questions[index];
        this.editingQuestion = {
          question: question.text || question.question || "",
          options: question.options ? [...question.options] : []
        };
        this.$store.dispatch("ai_assessment/startEditingQuestion", index);
      }
    },
    saveQuestion(index: number) {
      if (this.aiAssessmentData && this.aiAssessmentData.questions[index]) {
        const originalQuestion = this.aiAssessmentData.questions[index];
        const updatedQuestion = {
          ...originalQuestion,
          text: this.editingQuestion.question,
          options: this.editingQuestion.options
        };
        this.$store.dispatch("ai_assessment/saveQuestion", {
          index,
          question: updatedQuestion
        });
      }
    },
    async loadAvailableApplicants() {
      this.loadingApplicants = true;
      try {
        await this.$store.dispatch("recruiter/FETCH_AVAILABLE_APPLICANTS");
      } catch (error) {
        console.error("Failed to load available applicants:", error);
      } finally {
        this.loadingApplicants = false;
      }
    },
    onApplicantsChange(applicants: Applicant[]) {
      this.selectedApplicants = applicants;
      this.$store.commit("recruiter/SET_SELECTED_APPLICANTS", applicants);
      this.searchInput = "";
    },
    removeItem(item: any) {
      const applicants = this.selectedApplicants.filter(
        (applicant) => applicant.value !== item.value
      );
      this.selectedApplicants = applicants;
      this.$emit("applicants-change", applicants);
      this.searchInput = "";
    },
    getInitials(name: string): string {
      return name
        .split(" ")
        .map((word) => word.charAt(0))
        .join("")
        .toUpperCase()
        .slice(0, 2);
    },
    isArabic() {
      return localStorage.getItem("locale") === "ar";
    },
    async assignAssessmentToApplicants(assessmentId: number) {
      if (this.selectedApplicants.length === 0) {
        this.$store.commit(
          "ROOT_ERROR",
          this.$t("ai-assessments.generated.assign.select_at_least_one"),
          {
            root: true
          }
        );
        return false;
      }

      try {
        const ok = await this.ASSIGN_ASSESSMENT_TO_APPLICANTS({
          assessment_id: assessmentId
        });
        if (!ok) throw new Error("Assignment failed");

        const applicantNames = this.selectedApplicants
          .map((a) => a.label)
          .join(", ");
        this.$store.commit(
          "ROOT_NOTIFICATION",
          this.$t("ai-assessments.generated.assign.assigned_success", {
            names: applicantNames
          }),
          { root: true }
        );

        return true;
      } catch (error) {
        console.error("Failed to assign assessment to applicants:", error);
        this.$store.commit(
          "ROOT_ERROR",
          this.$t("ai-assessments.generated.assign.assigned_failed"),
          { root: true }
        );
        return false;
      }
    }
  }
});
